import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appTrialRequestLeaveRow]',
})
export class CustomPopup2Directive {
  @Input() pop1: NgbPopover;
  @Input() pop2: NgbPopover;
  @Input() pop3: NgbPopover;

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('mouseleave')
  public onMouseLeave() {
    if (this.pop1.isOpen()) {
      this.pop1.close();
    }
    if (this.pop2.isOpen()) {
      this.pop2.close();
    }
    if (this.pop3.isOpen()) {
      this.pop3.close();
    }
  }
}
